import React, { Component } from 'react';
import PropTypes from 'prop-types';
import apiDecorator from 'api/api-decorator';
import { reportError } from 'api/api-errors';
import { UserProp } from 'auth';
import { emit } from 'helpers/global-events';
import Form, {
  InputLabel,
  ImageInput,
  Text,
} from 'containers/form';
import Button, { btnThemes } from 'components/button';
import Notification from 'components/notification';
import { ModalButton, Header, Content, Footer } from 'components/modal';
import { iconTypes } from 'components/icon';

// Show button for join to club or exit from club.
@apiDecorator
export default class ClubButtonJoin extends Component {
  static propTypes = {
    className: PropTypes.string,
    // eslint-disable-next-line
    item: PropTypes.any,
    auth: UserProp,
    actionDoLogin: PropTypes.func,
    onClick: PropTypes.func,
    buttonProps: PropTypes.shape({}),
    dataClub: PropTypes.shape({})
  };

  constructor(props, ctx) {
    super(props, ctx);
    this.joinToClub = this.joinToClub.bind(this);
    this.afterJoin = this.afterJoin.bind(this);
    this.afterJoinClosed = this.afterJoinClosed.bind(this);
    this.checkClubType = this.checkClubType.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.exitClubButton = this.exitClubButton.bind(this);
    this.closedClubButton = this.closedClubButton.bind(this);
  }

  // After click on the send order.
  onSubmit() {
    emit('joinModal');

    Notification.success('Спасибо, Ваша заявка на вступление в закрытый клуб зарегистрирована. ' +
      'Вы можете наблюдать статус заявки на главной странице клуба. ' +
      'Вы получите сообщение о результате рассмотрения заявки.');
  }

  // Call after success join/exit to/from club.
  afterJoin(clubUserStatus, clubName) {
    if (clubUserStatus) {
      Notification.success(`Вы покинули клуб "${clubName}". Нам будет вас не хватать.`);
    } else {
      Notification.success(`Вы стали членом клуба "${clubName}". Желаем приятного общения.`);
    }

    if (this.props.onClick) this.props.onClick();

    // Make reload data provider.
    emit('updateClubList');

    // Make reload data provider for Vote.
    emit('updateVote');

    // Make reload data provider club posts.
    emit('updateClubPosts');

    // Make reload data provider for TopicInfo and posts.
    emit('updatePosts');

    return true;
  }

  // Call after success join/exit to/from closed club.
  afterJoinClosed(clubUserStatus, clubName) {
    if (clubUserStatus) {
      Notification.success(`Вы покинули клуб "${clubName}". Нам будет вас не хватать.`);
    } else {
      Notification.success(`Вы стали членом клуба "${clubName}". Желаем приятного общения.`);
    }

    if (this.props.onClick) this.props.onClick();

    // Make reload data provider.
    emit('updateClubList');

    // Make reload data provider for Vote.
    emit('updateVote');

    // Make reload data provider club posts.
    emit('updateClubPosts');

    // Make reload data provider for TopicInfo and posts.
    emit('updatePosts');

    return true;
  }

  // Check type of club. Is open then return true.
  checkClubType(dataClub) {
    if (dataClub.clubTypeValue === 'closed' && !dataClub.clubUserStatus) {
      return false;
    }

    return true;
  }

  // Join to club or exit from club.
  joinToClub(clubId, clubUserStatus, clubName) {
    const { auth: { authenticated } = {} } = this.props;

    if (authenticated) {
      this.api.post('action/club/actions-join-club/join', {
        postData: {
          clubId,
          clubUserStatus
        }
      })
        .then(() => this.afterJoin(clubUserStatus, clubName))
        .catch(error => reportError(error));
    } else {
      // Show LogIn form.
      this.props.actionDoLogin();
    }
  }

  // Show button for exit from club;
  exitClubButton() {
    const { className, item = {}, buttonProps = {} } = this.props;

    let exitText = 'После выхода публикация сообщений в этом клубе будет' +
                   'невозможна.';

    if (item.clubTypeValue === 'closed') {
      exitText = 'Это закрытый клуб и после выхода чтение тем будет невозможно.' +
                 'Чтобы снова стать членом клуба, необходимо будет делать новый запрос.';
    }

    return (
      <ModalButton
        className={className || ''}
        buttonProps={{
          ...buttonProps,
          iconType: iconTypes.logOut,
          label: 'Выйти из клуба',
          title: 'Выйти из клуба'
        }}
        size="medium"
      >
        <Header closeButton>Выйти из клуба</Header>
        <Content>
          <div>
            <div>
              Вы собираетесь выйти из клуба <b>{item.forum_title}</b>.
            </div>
            <div style={{ marginTop: 20 }}>
              {exitText}
            </div>
          </div>
        </Content>
        <Footer>
          <button
            theme={btnThemes.light}
            close
          >
            Отменить
          </button>
          <button
            onClick={() => this.joinToClub(
              item.id,
              item.clubUserStatus,
              item.forum_title
            )}
            theme={btnThemes.light}
            close
          >
            Выйти из клуба
          </button>
        </Footer>
      </ModalButton>
    );
  }

  // Show button for closed club.
  closedClubButton() {
    const { className, item = {}, buttonProps = {}, auth = {} } = this.props;

    const forum_id = item.id;
    const otherProps = {};

    otherProps.defaultValues = {
      forum_id
    };

    return (
      <ModalButton
        className={className || ''}
        buttonProps={{
          ...buttonProps,
          label: 'Вступить в клуб',
          title: 'Вступить в клуб',
          theme: btnThemes.sky,
          onClick: !auth.authenticated ? () => this.props.actionDoLogin() : null
        }}
        size="medium"
        closeEvent="joinModal"
      >
        <Header closeButton>Вступить в закрытый клуб</Header>
        <Content>
          <div>
            <div>
              Вы собираетесь подать заявку на вступление в закрытый клуб <b>{`"${item.forum_title}"`}</b>.
            </div>
            <div style={{ marginTop: 20 }}>
              Если это клуб Инвесторов в новостройку, для одобрения заявки необходимо предоставить
              фото договора об инвестировании или его части (без личных данных),
              где виден объект инвестирования и печать.
            </div>
            <Form
              controller="forum/join-closed-club-form"
              updateEvent="updateClubList"
              onSubmit={this.onSubmit}
              entityId={null}
              showPopupValidationMessages
              hFull
              {...otherProps}
            >
              <div>
                <InputLabel dataBind="images" />
                <ImageInput dataBind="images" circled />
              </div>
              <div>
                <Text dataBind="comment" />
              </div>
              <div>
                <Button
                  data-submit
                  label="Опубликовать"
                  theme={btnThemes.sky}
                  big
                />
                <Button
                  onClick={() => emit('joinModal')}
                  label="Отмена"
                  theme={btnThemes.sky}
                  big
                />
              </div>
            </Form>
          </div>
        </Content>
      </ModalButton>
    );
  }

  render() {
    const {
      className, item = {}, auth = {}, buttonProps = {}, dataClub = {}
    } = this.props;

    const isOpen = this.checkClubType(dataClub);

    if (auth.authenticated && item.clubUserStatus) {
      return this.exitClubButton();
    }

    // If closed club.
    if (!isOpen) {
      return this.closedClubButton();
    }

    // Show button for add to open club.
    return (
      <Button
        theme={btnThemes.sky}
        small
        {...buttonProps}
        className={className || ''}
        onClick={() => this.joinToClub(
          item.id,
          item.clubUserStatus,
          item.forum_title
        )}
        title="Вступить в клуб"
        label="Вступить в клуб"
      />
    );
  }
}
